import { I18nComponente } from "@/types/gerais"

export const MCarregadorDeArquivosi18n: I18nComponente = {
  "pt-BR": {
    excedeTamanhoMaximoPermitido: "excede o tamanho máximo permitido de 500 KB",
    formatoDoArquivo: "formato do arquivo inválido",
    invalidoArquivoDeveSerDoTipoXLSX: "inválido, o arquivo deve ser do tipo xlsx",
    selecionarArquivo: "selecionar arquivo",
    importarTudo: "importar tudo",
    limparLista: "limpar lista",
    aoImportarArquivoSeraFeitoDownload: "ao importar o arquivo, será feito o download automático de dois arquivos CSV indicando linhas com erros e linhas cuja importação foi um sucesso",
    formatoAceitoXLSX: "formato aceito: xlsx",
    tamanhoMaximoDeArquivo: "tamanho máximo de arquivo: 500 KB",
    finalizado: "finalizado",
    falhaAoImportar: "falha ao importar",
    aguardando: "aguardando",
    importando: "importando",
    importacaoFinalizada: "importação finalizada",
    todosOsArquivosForamImportadosComSucesso: "todos os arquivos foram importados com sucesso",
    todosOsArquivosFalharamAoSeremImportados: "todos os arquivos falharam ao serem importados",
    algunsArquivosFalharamAoSeremImportados: "alguns arquivos falharam ao serem importados",
  },
  "es-CO": {
    excedeTamanhoMaximoPermitido: "excede el tamaño máximo permitido de 500 KB",
    formatoDoArquivo: "formato de archivo inválido",
    invalidoArquivoDeveSerDoTipoXLSX: "inválido, el archivo debe ser del tipo xlsx",
    selecionarArquivo: "seleccionar archivo",
    importarTudo: "importar todo",
    limparLista: "borrar lista",
    aoImportarArquivoSeraFeitoDownload: "al importar el archivo, se descargará automáticamente dos archivos CSV que indican las líneas con errores y las líneas cuya importación fue un éxito",
    formatoAceitoXLSX: "formato aceptado: xlsx",
    tamanhoMaximoDeArquivo: "tamaño máximo de archivo: 500 KB",
    finalizado: "finalizado",
    falhaAoImportar: "fallo al importar",
    aguardando: "esperando",
    importando: "importando",
    importacaoFinalizada: "importación finalizada",
    todosOsArquivosForamImportadosComSucesso: "todos los archivos se importaron con éxito",
    todosOsArquivosFalharamAoSeremImportados: "todos los archivos fallaron al importarse",
    algunsArquivosFalharamAoSeremImportados: "algunos archivos fallaron al importarse",
  }
}
